import { registraGlobalComponents } from '@/app'

import VPicture        from './VPicture.vue'
import BtnWhatsappFixo from './BtnWhatsapp/BtnWhatsappFixo.vue'
import KCookies        from './KCoockies.vue'
import VAffix          from './VAffix.vue'
import KSlider         from './KSlider.vue'
import LogoKryzalis    from './LogoKryzalis.vue'

import KInput from './KInput.vue'
import KFile from './KFile.vue'

registraGlobalComponents({
	KInput,
	VPicture,
	BtnWhatsappFixo,
	KCookies,
	VAffix,
	KSlider,
	LogoKryzalis,
	KFile
})
